<div *ngIf="!pdfUrl || pdfUrl==''" class="loader-box">
    <dx-load-indicator class="loader-indicator"></dx-load-indicator>
    <h6 class="loader-msg">Loading Report...</h6>
</div>

<!-- <ngx-extended-pdf-viewer [ngClass]="pdfUrl==''?'d-none':''" 
    [src]="pdfUrl"
    [showToolbar]="true"
    [showSidebarButton]="false"
    [showFindButton]="false"
    [showPagingButtons]="false"
    [showEditor]="false"
    [showZoomButtons]="true"
    [showPresentationModeButton]="false"
    [showOpenFileButton]="false"
    [showPrintButton]="true"
    [showDownloadButton]="true"
    [showSecondaryToolbarButton]="true"
    [showRotateButton]="false"
    [showHandToolButton]="false"
    [showScrollingButton]="false"
    [showSpreadButton]="false"
    [showPropertiesButton]="false"
    [filenameForDownload]="fileName"
    [printResolution]="'700'"
    [customToolbar]="customToolbar"
    [sidebarVisible]="false"
></ngx-extended-pdf-viewer>

<ng-template #customToolbar>
    <div id="toolbarViewer">
        <div id="toolbarViewerLeft">
            <pdf-paging-area></pdf-paging-area>
        </div>
        <div id="toolbarViewerRight">
            <pdf-print></pdf-print>
            <pdf-download></pdf-download>
        </div>
        <pdf-zoom-toolbar ></pdf-zoom-toolbar>
    </div>
</ng-template> -->
<!-- <div *ngIf="pdfUrl && pdfUrl!=''" class="preview-pdf-sec">
    <iframe  [src]="pdfUrl" class="pdf-frame" width="100%" height="100%" style="overflow: auto;" type='application/pdf'></iframe>
</div> -->


<!-- <div *ngIf="pdfUrl && pdfUrl!=''" class="preview-pdf-sec">
    <embed text="PSR" [src]="pdfUrl" class="pdf-frame" type='application/pdf'>
</div> -->

<div *ngIf="pdfUrl && pdfUrl!=''" class="preview-pdf-sec" >
    <div class="pdf-toolbar-block">
        <dx-toolbar
            class="pdf-toolbar"
            >
            <dxi-item location="before" widget="dxButton" locateInMenu="never">
              <div *dxTemplate>
                <div class="toolbar-label"><b>{{this.fileName}}</b></div>
              </div>
            </dxi-item>
            <dxi-item
              location="after"
              widget="dxButton"
              locateInMenu="auto"
              [options]="{icon:'print',onClick:printPdf}"
            >
            </dxi-item>
            <dxi-item
              location="after"
              widget="dxButton"
              locateInMenu="auto"
              [options]="{icon:'download',onClick:downloadPdf}"
            >
            </dxi-item>
          </dx-toolbar>
    </div>
    <pdf-viewer
        [src]="pdfUrl"
        [render-text]="true"
        [render-text-mode]="3"
        [external-link-target]="'blank'"
        [rotation]="0"
        [show-all]="true"
        [show-borders]="false"
        [original-size]="true"
        [fit-to-page]="true"
        class="pdf-viewer"
        ></pdf-viewer>
</div>

<!-- <div *ngIf="pdfUrl && directDownload" class="loader-box">
    <dx-button (click)="downloadPdf()" class="loader-msg" icon="download" text="Download Pdf" stylingMode="contained" type="text"></dx-button>
</div> -->

<app-confirmation-popup *ngIf="openConfirmationPopup" [option]="confirmationPopupOption" (onConfirmed)="openConfirmationPopup=false"></app-confirmation-popup>


